import { createRouter, createWebHistory } from 'vue-router'
// import LP02 from '../views/LP02.vue'
// import LP03 from '../views/LP03.vue'
// import LP04 from '../views/LP04.vue'
// import LP05 from '../views/LP05.vue'
// import LP06 from '../views/LP06.vue'
// import LP07 from '../views/LP07.vue'
// import LP08 from '../views/LP08.vue'
import LP09 from '../views/LP09.vue'
// import LP10 from '../views/LP10.vue'
import LP11 from '../views/LP11.vue'
import LP01 from '../views/LP.vue'
import LP12 from '../views/LP12.vue'
// import ECO from '../views/ECO.vue'
import InformationPage from '../views/InformationPage.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import NotFound from '../views/NotFound.vue'

const routes = [
  { path: '/', component: LP09 },
  { path: '/gas', component: NotFound },
  // { path: '/gas/lp02', component: LP02 },
  // { path: '/gas/lp03', component: LP03 },
  // { path: '/gas/lp04', component: LP04 },
  // { path: '/gas/lp05', component: LP05 },
  // { path: '/gas/lp06', component: LP06 },
  // { path: '/gas/550e8400-e29b-41d4', component: LP07 },
  // { path: '/gas/lp08', component: LP08 },
  { path: '/gas/lp09', component: LP09 },
  { path: '/gas/0e8400-e4jw-41d4', component: LP11 },
  // { path: '/gas/550e8400-e29b-41d5', component: LP10 },
  { path: '/prottool/lp01', component: LP01 },
  { path: '/gas/kansai/lp01', component: LP12 },
  // { path: '/ecocute/lp01', component: ECO },
  { path: '/InformationPage', component: InformationPage },
  { path: '/privacy-policy', component: PrivacyPolicy },
  { path: '/:pathMatch(.*)*', component: NotFound },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
